import { render, staticRenderFns } from "./DettaglioEmail.vue?vue&type=template&id=042975b5"
import script from "./DettaglioEmail.vue?vue&type=script&lang=js"
export * from "./DettaglioEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports